/**
 * Shared section chrome: applies admin-configurable background colour
 * and optionally renders a grass-silhouette top border (used on whichever
 * section is first after the hero).
 *
 * Default background is per-section to preserve the original visual design.
 * Admin can override any of these via content.section_styles[id].
 */

// Base body backgrounds — match THEMES.bg so sections blend with the page.
const BODY_LIGHT = '#ffffff';
const BODY_DARK = '#111827'; // bg-gray-900
const BODY_BLACK = '#111111';

// Per-section defaults matching the original hard-coded styling.
const DEFAULTS = {
  features:    { light: '#f9fafb', dark: '#1f2937', black: '#1a1a1a' },
  pricing:     { light: '#f9fafb', dark: '#1f2937', black: '#1a1a1a' },
  // All other sections inherit the body bg so they blend seamlessly.
};

const bodyBgFor = (theme) => theme === 'black' ? BODY_BLACK : theme === 'dark' ? BODY_DARK : BODY_LIGHT;

export function getSectionBg(content, id, theme) {
  const override = content?.section_styles?.[id] || {};
  const def = DEFAULTS[id] || { light: BODY_LIGHT, dark: BODY_DARK, black: BODY_BLACK };
  if (theme === 'black') return override.bgColorBlack || def.black || def.dark;
  if (theme === 'dark') return override.bgColorDark || def.dark;
  return override.bgColor || def.light;
}

export function getDefaultSectionBg(id, theme) {
  const def = DEFAULTS[id] || { light: BODY_LIGHT, dark: BODY_DARK, black: BODY_BLACK };
  if (theme === 'black') return def.black || def.dark;
  return theme === 'dark' ? def.dark : def.light;
}

export function GrassTopBorder({ bgColor }) {
  return (
    <div
      className="absolute left-0 right-0 w-full pointer-events-none"
      style={{
        height: '22px',
        bottom: '100%',
        marginBottom: '-1px',
        backgroundColor: bgColor,
        WebkitMaskImage: 'url(/grass-border.png)',
        WebkitMaskSize: 'auto 100%',
        WebkitMaskRepeat: 'repeat-x',
        WebkitMaskPosition: 'center bottom',
        maskImage: 'url(/grass-border.png)',
        maskSize: 'auto 100%',
        maskRepeat: 'repeat-x',
        maskPosition: 'center bottom',
      }}
    />
  );
}

export function SectionChrome({ id, isFirst, theme, content, children }) {
  const bg = getSectionBg(content, id, theme);
  return (
    // `z-10` ensures sections paint above the hero when hero is in
    // sticky-content mode. Harmless when hero is in normal scroll mode.
    <div className="relative z-10" style={{ backgroundColor: bg }}>
      {isFirst && <GrassTopBorder bgColor={bg} />}
      {children}
    </div>
  );
}
